// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2379":"79fa4f42c92d1a60","2888":"c27a9de16369bd8a","5693":"79fa4f42c92d1a60","7953":"79fa4f42c92d1a60","8306":"79fa4f42c92d1a60"}[chunkId] + ".css";
};